import { gql } from "@apollo/client";

export const VIEWER_COUNTRY = gql`
  query viewerCountry {
    viewerCountry
  }
`;

export const GET_CONTENTFUL_ENTRY = gql`
  query getContentfulEntry(
    $entryId: String!
    $branchName: String!
    $preview: Boolean
    $entryParams: JSON
  ) {
    getContentfulEntry(
      entryId: $entryId
      branchName: $branchName
      preview: $preview
      entryParams: $entryParams
    )
  }
`;

export const CONTENTFUL_ENTRIES = gql`
  query getContentfulEntries(
    $entryIds: [String!]!
    $branchName: String!
    $preview: Boolean
    $entriesParams: [JSON!]
  ) {
    getContentfulEntries(
      entryIds: $entryIds
      branchName: $branchName
      preview: $preview
      entriesParams: $entriesParams
    )
  }
`;

export const CONTENTFUL_ENTRY_BY_SLUG = gql`
  query getContentfulEntryBySlug(
    $slug: String!
    $contentType: String!
    $branchName: String!
    $preview: Boolean
    $contentSlugParams: JSON
  ) {
    getContentfulEntryBySlug(
      slug: $slug
      contentType: $contentType
      branchName: $branchName
      preview: $preview
      contentSlugParams: $contentSlugParams
    )
  }
`;

export const EMAIL_CONTACT = gql`
  mutation addEmailContact(
    $email: String!
    $country: String!
    $source: String!
  ) {
    addEmailContact(email: $email, country: $country, source: $source)
  }
`;
